import styled from "styled-components";

export const ServiceCommentStyles = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
  border-radius: ${({ theme }) => theme.radius[12]};
  background: ${({ theme }) => theme.colors.semantic.container.white};
  padding: ${({ theme }) => theme.spacing[12]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[8]};

  .commentUserRow {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing[8]};

    .commentUser {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      align-items: center;
    }

    .commentUserDetails {
      display: flex;
      align-items: center;
      gap: ${({ theme }) => theme.spacing[8]};
      min-width: 0;
    }

    .commentAvatar {
      flex: 0 0 auto;
      width: 32px;
      height: 32px;
      border-radius: ${({ theme }) => theme.radius.rounded};
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${({ theme }) => theme.colors.semantic.container.gray};
      color: ${({ theme }) => theme.colors.semantic.text.strong};

      .commentProfileImage {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .commentAvatarInitials {
        font-family: ${({ theme }) => theme.typography.fontFamily};
        font-size: ${({ theme }) => theme.typography.body.b3.size};
        line-height: 1;
        font-weight: ${({ theme }) => theme.typography.title.t2.weight};
        color: ${({ theme }) => theme.colors.semantic.text.strong};
        text-transform: uppercase;
        user-select: none;
      }
    }

    .commentUserMeta {
      min-width: 0;
    }

    .commentUserName {
      margin: 0;
      font-family: ${({ theme }) => theme.typography.fontFamily};
      font-size: ${({ theme }) => theme.typography.title.t2.size};
      line-height: ${({ theme }) => theme.typography.title.t2.lineHeight};
      font-weight: ${({ theme }) => theme.typography.title.t2.weight};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .commentBody {
    min-width: 0;
  }

  .commentText {
    margin: 0;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    font-weight: ${({ theme }) => theme.typography.body.b2.weight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }

  .commentDateRow {
    display: flex;
    justify-content: flex-end;

    .commentDate {
      margin: 0;
      font-family: ${({ theme }) => theme.typography.fontFamily};
      font-size: ${({ theme }) => theme.typography.body.b3.size};
      line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
      font-weight: ${({ theme }) => theme.typography.body.b3.weight};
      color: ${({ theme }) => theme.colors.semantic.text.weak};
    }
  }

  .commentDeleteBtn {
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    padding: 0;
    background: transparent;
    border-radius: ${({ theme }) => theme.radius.rounded};
    cursor: pointer;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    transition: background 0.15s ease, color 0.15s ease;

    svg {
      width: 14px;
      height: 16px;
    }

    &:hover {
      background: ${({ theme }) => theme.colors.error[500]};
      color: #fff;
    }
  }
`;
